import * as ActionTypes from '../../constants/revenue/ActionTypes'
import update from 'immutability-helper'

// 수익센터 개발 기간 동안 Tester 체크
const checkRevenueTester = () => {
    const developers = ["3128203", "4235718", "3356046", "3502843", "1", "363075", "2568757", "3486340", "3868508", "3486052", "2924599", "17840", "2960053", "2878888", "463", "115962"]; // prod 환경에서 허용할 blogId 추가
    const betaTesters = ["3067013", "845844", "3174745", "3838126", "2847979", "89210", "1945942", "1558649", "2767662", "3172601", "463", "3028403"];

    const prodBlogIds = developers.concat(betaTesters);

    if (window.Config.service !== "tistory") {
        return false;
    }
    if (!window.Config.production) {
        return true;
    } else {
        if (prodBlogIds.includes(window.Config.blog.blogSettings.blogId)) {
            return true;
        }
    }
    return false;
};

const initialState = {
    tester: checkRevenueTester(), // 개발기간 동안 임시
    revenueVendors: window.appInfo.revenueVendors,
    adsenseInfo: null,
    adfitInfo: null,
};

export default (state = initialState, action) => {
    switch(action.type) {
        case ActionTypes.SET_ADSENSE_INFO:
            return update(state, {
                adsenseInfo: {
                    $set: action.adsenseInfo
                }
            });
        case ActionTypes.SET_ADFIT_INFO:
            return update(state, {
                adfitInfo: {
                    $set: action.adfitInfo
                }
            });
        default:
            return state;
    }
}
